import '@/modules/cart';
import { CartItems, CartRemoveButton, CartRemoveBundleButton, QuantityInput } from '@/modules/cart';
import CartBundle from '@/modules/cart-bundle';

if (document.getElementsByTagName('cart-items')) {
    const bundleOverlays = document.querySelectorAll('.js-bundle-overlay');
    if (bundleOverlays) {
        customElements.define('cart-bundle', CartBundle);
    }
    
    customElements.define('cart-items', CartItems);
}

if (document.getElementsByTagName('cart-remove-button')) {
    customElements.define('cart-remove-button', CartRemoveButton);
}

if (document.getElementsByTagName('cart-remove-bundle-button')) {
    customElements.define('cart-remove-bundle-button', CartRemoveBundleButton);
}

if (document.getElementsByTagName('quantity-input')) {
    customElements.define('quantity-input', QuantityInput);
}
